// extracted by mini-css-extract-plugin
export default {"line":"TimelineStep_line__FQn33","icon":"TimelineStep_icon__BNBfr"};